import { createAction } from '@reduxjs/toolkit';

export const ADD_EMPTY_ARRAY_USER_ORDERS = 'orders/getEmptyArrayUserOrders';

export const addEmptyArrayUserOrders = createAction(
    ADD_EMPTY_ARRAY_USER_ORDERS,
    () => ({ payload: { orders: [] } }),
);
